var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.containerClasses }, [
    _c(
      "div",
      { class: _vm.inline ? "d-flex align-items-center" : "" },
      [
        _vm.label
          ? _c(
              "div",
              { class: _vm.mergedLabelClasses },
              [
                _vm._t("label-prefix"),
                _vm._v(" "),
                _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } }),
                _vm._v(" "),
                _vm.labelTooltip
                  ? _c(
                      "span",
                      {
                        directives: [
                          { name: "b-tooltip", rawName: "v-b-tooltip" }
                        ],
                        staticClass: "ml-2",
                        attrs: { title: _vm.labelTooltip }
                      },
                      [_c("Icon", { attrs: { icon: "info" } })],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.feedbackBeneath &&
        !_vm.inline &&
        _vm.state === false &&
        _vm.invalidFeedback
          ? _c("div", { staticClass: "error mb-2" }, [
              _vm._v(_vm._s(_vm.invalidFeedback))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    ),
    _vm._v(" "),
    _vm.description
      ? _c("div", { staticClass: "mt-1 font-size-small font-italic" }, [
          _vm._v(_vm._s(_vm.description))
        ])
      : _vm._e(),
    _vm._v(" "),
    (_vm.feedbackBeneath || _vm.inline) &&
    _vm.state === false &&
    _vm.invalidFeedback
      ? _c("div", { staticClass: "error mt-2" }, [
          _vm._v(_vm._s(_vm.invalidFeedback))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }